import React, { useContext, useEffect, useRef, useState } from 'react';
import { AuthContextClient } from '../context/AuthContextClient';
import { Col, Container, Row } from 'react-bootstrap';
import { Toaster, toast } from 'react-hot-toast';

const LoginComponentClient = () => {
  const { clientLogin, error, userClient, clearError } =
    useContext(AuthContextClient);
  const [password, setPassword] = useState('');
  const [isInvalid, setIsInvalid] = useState(false);
  const focusInputRef = useRef(null);

  useEffect(() => {
    focusInputRef.current.focus();
  }, []);

  useEffect(() => {
    if (error) {
      toast.error(error);
      setIsInvalid(true);
      focusInputRef.current.focus();
    }
  }, [error]);

  const handleLogin = async (event) => {
    event.preventDefault();
    clearError(); // Clear any previous errors
    if (!password) {
      setIsInvalid(true);
      toast.error('Please enter the password');
      focusInputRef.current.focus();
    } else {
      setIsInvalid(false);
      try {
        focusInputRef.current.blur();
        await clientLogin(password); // Wait for the login attempt to complete
      } catch (err) {
        // Error handling is now done via the useEffect that watches the error state
        focusInputRef.current.focus();
      }
    }
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setIsInvalid(false);
  };

  if (userClient) {
    // If user is logged in, the parent component handles the routing based on URL
    return null;
  }

  return (
    <Container fluid>
      <Row>
        <Toaster />
        <Col
          className="text-center"
          style={{
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div className="p-2">
            <h6 className="h5">Log In</h6>
          </div>
          <form onSubmit={handleLogin} autoComplete="off" data-bwignore="true">
            <div className="form-floating mb-3">
              <input
                id="client-password"
                name="client-password"
                className={`form-control ${isInvalid ? 'is-invalid' : ''}`}
                type="password"
                autoComplete="off"
                data-bwignore="true"
                placeholder="Password"
                value={password}
                ref={focusInputRef}
                onChange={handlePasswordChange}
              />
              <label htmlFor="client-password">Password</label>
            </div>
            <button type="submit" className="btn btn-primary">
              Sign in
            </button>
          </form>
        </Col>
      </Row>
    </Container>
  );
};

export default LoginComponentClient;
